import { I18n, LanguageKey } from "../types";

const loadAdditionalTranslations = ({
  currentLocale,
  extend,
}: I18n) => async () => {
  if (currentLocale) {
    const localeToLoad = Object.keys(LanguageKey).find(
      (pattern) =>
        currentLocale.indexOf(pattern) >= 0 ||
        currentLocale.split("-")[0].indexOf(pattern) >= 0
    ) as LanguageKey;

    const defaultLanguage = LanguageKey["en-us"];
    const newLanguage = LanguageKey[localeToLoad];

    if (localeToLoad !== defaultLanguage && newLanguage) {
      const locale = await import(
        /* webpackChunkName: "locale-[request]" */ `../locales/${newLanguage}.json`
      );

      extend(locale);
    }
  }
};

export default loadAdditionalTranslations;
